import { render, staticRenderFns } from "./edit-ticket.vue?vue&type=template&id=64e424a4&scoped=true"
import script from "./edit-ticket.vue?vue&type=script&lang=js"
export * from "./edit-ticket.vue?vue&type=script&lang=js"
import style0 from "./edit-ticket.vue?vue&type=style&index=0&id=64e424a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e424a4",
  null
  
)

export default component.exports